import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  TeButtonMinimal,
  TeCallout,
  TeCell,
  TeContainer,
  TeContainerSlim,
  TeModal,
  TeRow,
  TeTable,
  TeText,
} from '@topcon/tuicl-react';

import { Section } from '../../../utils/styling';
import Header from '../../../components/Header';
import EulaContent from '../../../components/Eula/EulaContent';
import { useEula } from '../../../components/Eula/useEula';
import { printEula } from '../../../components/Eula/helpers/printEula';

const LegalDocuments = () => {
  const { t } = useTranslation('settings');
  const eula = useEula();
  const [reviewOpen, setReviewOpen] = useState(false);
  const title = t('termsAndConditions', { ns: 'common' });

  return (
    <TeContainer column grow gap="xs" padding="xs" overflow="auto" alignItems="center">
      <Header text={t('legalDocuments.title')} />

      <Section>
        <TeContainer column fill gap="s">
          <TeCallout status="info" icon="info" text={t('legalDocuments.info')} grow />
          <TeTable evenOdd>
            <TeRow>
              <TeCell>
                <TeText weight="bold">{t('legalDocuments.documentName')}</TeText>
              </TeCell>
              <TeCell compact minWidth={200}>
                <TeText weight="bold">{t('legalDocuments.lastUpdated')}</TeText>
              </TeCell>
              <TeCell compact>
                <TeText weight="bold">{t('legalDocuments.options')}</TeText>
              </TeCell>
            </TeRow>
            <TeRow>
              <TeCell>
                <TeText>{title}</TeText>
              </TeCell>
              <TeCell compact minWidth={200}>
                <TeText>{eula.content?.updatedOn ?? '—'}</TeText>
              </TeCell>
              <TeCell compact>
                <TeContainerSlim gap="xs">
                  <TeButtonMinimal
                    icon="visibility"
                    variant="neutral"
                    size="s"
                    title={t('legalDocuments.review')}
                    teclick={() => setReviewOpen(true)}
                  />
                  <TeButtonMinimal
                    icon="download"
                    variant="neutral"
                    size="s"
                    title={t('legalDocuments.print')}
                    disabled={!eula.content}
                    teclick={() =>
                      eula.content &&
                      printEula(eula.content, title, t('legalDocuments.lastUpdated'))
                    }
                  />
                </TeContainerSlim>
              </TeCell>
            </TeRow>
          </TeTable>
        </TeContainer>
      </Section>

      <TeModal
        open={reviewOpen}
        closeable
        closeMode="button"
        modalTitle={title}
        size="m"
        width="xl"
        teclose={() => setReviewOpen(false)}
      >
        {reviewOpen && <EulaContent {...eula} />}
      </TeModal>
    </TeContainer>
  );
};

export default LegalDocuments;
